import aboutCn from './about.cn'
import navigationsCn from './navigations.cn'

module.exports = {
  messages: {
    login: '登录',
    back: '返回',
    tab: [
      {
        title: '首页',
        children: []
      },
      {
        title: '研究院概况',
        // children: ['研究院简介', '研究院领导', '历任领导', '行政办公']
        children: ['研究院简介', '研究院领导', '行政办公']
      },
      {
        title: '研究中心'
      },
      {
        title: '师资队伍',
        children: ['教师名录', '杰出人才', '博士后']
      },
      {
        title: '新闻通告',
        children: ['新闻信息', '学术动态', '通知公告', '招聘信息']
      },
      {
        title: '人才培养',
        children: ['吴文俊人工智能荣誉博士班']
      },
      {
        title: '科学研究',
        children: ['学科基地', '科研成果']
      },
    ],
    slogan: '智算未来 能赋无界',
    newsButton: '阅读详情',
    messageMenu: [
      {
        title: '新闻信息',
      },
      {
        title: '通知公告',
      },
      {
        title: '学术动态',
      }
    ],
    messageButton: '查看更多',
    advertising: '上海交通大学人工智能研究院<br/>面向全球诚聘英才。',
    advertisingButton: '了解详情',
    scienceMessagesMore: '查看所有',
    scienceMessagesTitle: '科研成果',
    scienceMessagesButton: '详情',
    addressTitle: '联系我们',
    address: '上海市闵行区东川路800号上海交通大学软件大楼5楼',
    phone: '021-34206041',
    email: 'AI_SJTU@sjtu.edu.cn',
    sign: '上海交通大学',
    searchTitle: '检索你关心的内容',
    searchSecondTitle: '将在网站全局检索你的关键词',
    searchButton: '搜索',
    about: aboutCn,
    navigations: navigationsCn,
    facultyNavigations: [
      {
        name: '教师名录',
        nav: 'teachers'
      },
      {
        name: '杰出人才',
        nav: 'talent'
      },
      {
        name: '博士后',
        nav: 'postdoctoral'
      }
    ],
    teacherSearchText: '输入姓名检索',
    teacherSearchOptionOne: '研究方向',
    teacherSearchOptionTwo: '职称',
    teacherMoreButton: '查看详情',
    teacherNull: '未搜到相关信息，请更换筛选条件或重新输入',
    postgraduateNull: '暂无相关导师',
    talentOptionTitle: '人才类别',
    postgraduateMenu: ['导师介绍', '培养管理'],
    postgraduateOptionTitle: '导师介绍',
    cultivateNavigations: [
      {
        name: '吴文俊人工智能荣誉博士班',
        nav: 'postgraduate'
      },
    ],
    details: '详情',
    researchNavigations: [
      // {
      //   name: '研究方向',
      //   nav: 'directions'
      // },
      {
        name: '学科基地',
        nav: 'base'
      },
      {
        name: '科研成果',
        nav: 'results'
      },
    ],
    jointBaseUnfold: '查看详情',
    // jointBaseShrink: '点击收起详情',
    jointBaseButton: '进入网站',
    paperTitle: [
      '序号',
      '论文题目',
      '作者'
    ],
    newsNavigations: [
      {
        name: '学术动态',
        nav: 'academic'
      },

      {
        name: '通知公告',
        nav: 'announcements'
      },
      {
        name: '新闻信息',
        nav: 'news'
      },
      {
        name: '招聘信息',
        nav: 'jobs'
      }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/cn.js